export default "__VITE_ASSET__5896f860__"